import { axiosApiCall } from "../axios/customInstance";
import { storeAuthToken } from "../axios/tokenManager";
import { storeAuthority } from "../axios/authorityManager";
import { storeStaffId} from "../axios/CurrentMedicalStaffManager";
import { storeStaffName} from "../axios/CurrentMedicalStaffManager";
import { storeStaffSurname} from "../axios/CurrentMedicalStaffManager";
import { storeStaffEmail} from "../axios/CurrentMedicalStaffManager";
import { storeStaffFiscalCode} from "../axios/CurrentMedicalStaffManager";

export const authenticate = async (email, password) => {
  const url = "/authenticate";
  const authenticationData = {
    email: email,
    password: password,
  };

  try {
    const response = await axiosApiCall.post(url, authenticationData);
    console.log(response);
    storeAuthToken(response.data.token); // todo: manage the memory because the role is not automatically loaded
    storeAuthority(response.data.authority);
    storeStaffId(response.data.id);
    storeStaffName(response.data.name);
    storeStaffSurname(response.data.surname);
    storeStaffEmail(response.data.email);
    storeStaffFiscalCode(response.data.fiscalCode);
    return response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const logout = () => {
  removeAuthToken();
  removeAuthority();
  removeStaffDetails();
  console.log("User logged out");
};

// tokenManager.js
export const removeAuthToken = () => {
  window.localStorage.removeItem("auth_token");
};

// authorityManager.js
export const removeAuthority = () => {
  window.localStorage.removeItem("authority");
};

// CurrentMedicalStaffManager.js
export const removeStaffDetails = () => {
  window.localStorage.removeItem("staff_id");
  window.localStorage.removeItem("staff_name");
  window.localStorage.removeItem("staff_surname");
  window.localStorage.removeItem("staff_email");
  window.localStorage.removeItem("staff_fiscalCode");
};